// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const milcery: PokeData = {
  "id": 868,
  "name": "milcery",
  "height": 2,
  "weight": 3,
  "base_experience": 54,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "recover",
    "acid-armor",
    "sweet-kiss",
    "charm",
    "attract",
    "sweet-scent",
    "aromatherapy",
    "entrainment",
    "draining-kiss",
    "misty-terrain",
    "aromatic-mist",
    "dazzling-gleam"
  ],
  "moves": [
    "tackle",
    "sweet-kiss",
    "aromatherapy",
    "misty-terrain",
    "dazzling-gleam",
    "moonblast",
    "heal-bell",
    "guardian-bond",
    "mist-terrain",
    "hyper-voice",
    "starfall",
    "spirit-break",
    "play-rough"
  ],
  "evolution_chain": {
    "id": 452,
    "item": null,
    "species": [
      {
        "name": "milcery",
        "order": 868,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "alcremie",
        "order": 869,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 868,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.SPIN
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.75,
    "speed": 34,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
